import React from "react";
import Analytics from "./Analytics";
import AnalyticsPlayables from "./AnalyticsPlayables";
import AnalyticsConversion from "./AnalyticsConversion";

export default function AnalyticsPage() {
    return (
        <>
            <Analytics/>
            <AnalyticsPlayables/>
            <AnalyticsConversion/>
        </>
    );
}